import { useState } from "react";
import { ListSection, SearchForSection } from "../../shared";
import AllDoctorsDrugs from "./AllDoctorsDrugs.component";
import SelectMedicalGroup from "./SelectMedicalGroupModal.components";
import { IDoctor } from "../../interfaces/api";

const DoctorDrugModal = ({
  setOpenModal,
  confirmDoctors,
  actualData,
}: {
  setOpenModal: any;
  confirmDoctors: (data: IDoctor[]) => void;
  actualData: IDoctor[] | undefined;
  stepModal?: boolean;
}) => {
  const [showAllDoctors, setShowAllDoctors] = useState(false);
  const [showMedicalGroups, setShowMedicalGroups] = useState<boolean>(false);
  const [doctorInfo, setDoctorInfo] = useState<IDoctor>();
  const [componentList, setComponentList] = useState<IDoctor[]>(
    actualData ? actualData : []
  );
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const doctorProviderID = sessionStorage.getItem("doctorProviderID");

  const handleViewAllDoctorsClick = () => {
    setShowAllDoctors(true);
  };

  const handleBackButtonClick = () => {
    setShowAllDoctors(false);
    setShowMedicalGroups(false);
  };

  const handleViewMedicalGroups = (doctor: IDoctor) => {
    setShowAllDoctors(false);
    setDoctorInfo(doctor);
    setShowMedicalGroups(true);
  };

  const AddDocDrug = (data: IDoctor) => {
    const isSpecialistInList = componentList.filter(
      (doctor) =>
        doctor.ahRecords[0].providerCategory[0] ===
        "Primary Care Provider (PCP)"
    );
    if (
      data.ahRecords[0].providerCategory[0] === "Primary Care Provider (PCP)" &&
      isSpecialistInList.length >= 1 &&
      doctorProviderID
    ) {
      setShowMessage(true);
    } else {
      setComponentList(componentList.concat(data));
      setShowMessage(false);
    }
  };

  const handleRemoveDoctor = (
    providerID: string,
    npi: string,
    provider: boolean
  ) => {
    const updatedComponentList = componentList.filter((doctor) => {
      const shouldRemoveDoctor =
        doctor.npi === npi &&
        doctor.ahRecords.some((record) => record.providerID === providerID);

      return !shouldRemoveDoctor;
    });
    provider && sessionStorage.removeItem("doctorProviderID");
    setComponentList(updatedComponentList);
  };

  const onConfirm = (componentList: IDoctor[]) => {
    const isPCPProvider = componentList.find(
      (doctor) =>
        doctor.ahRecords[0].providerCategory[0] ===
        "Primary Care Provider (PCP)"
    );
    isPCPProvider &&
      sessionStorage.setItem(
        "doctorProviderID",
        isPCPProvider.ahRecords[0].providerID
      );
    confirmDoctors(componentList);
    setOpenModal(false);
  };

  return (
    <div
      className="popup"
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(0, 0, 0, 0.6)",
        zIndex: 9998,
      }}
    >
      <div
        className="popup-wrapper"
        style={{
          margin: 20,
          width: "1200px",
          display: "flex",
          background: "white",
          flexDirection: "column",
        }}
      >
        {(showAllDoctors || showMedicalGroups) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <button
              type="button"
              className="text-underline primary-color hide-for-small-only"
              style={{
                cursor: "pointer",
                paddingLeft: "70px",
                fontWeight: 500,
                fontSize: "25px",
              }}
              onClick={handleBackButtonClick}
            >
              &lt; Back to search
            </button>
            <button
              type="button"
              className="text-underline primary-color show-for-small-only"
              style={{
                cursor: "pointer",
                paddingLeft: "20px",
                fontWeight: 500,
                fontSize: "25px",
              }}
              onClick={handleBackButtonClick}
            >
              &lt; Back to search
            </button>
            <button
              type="button"
              style={{
                padding: "20px",
                cursor: "pointer",
              }}
              onClick={() => {
                setOpenModal(false);
              }}
            >
              X
            </button>
          </div>
        )}
        {!showAllDoctors && !showMedicalGroups && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              style={{
                padding: "20px",
                cursor: "pointer",
              }}
              onClick={() => {
                setOpenModal(false);
              }}
            >
              X
            </button>
          </div>
        )}
        {!showAllDoctors && !showMedicalGroups ? (
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <SearchForSection
              handleViewAllDoctorsClick={handleViewAllDoctorsClick}
              handleViewMedicalGroups={handleViewMedicalGroups}
            />
            <ListSection
              doctors={componentList}
              onRemove={handleRemoveDoctor}
              showMessage={showMessage}
            />
            <div style={{ flex: 1 }}></div>
            <div
              style={{
                alignSelf: "center",
              }}
            >
              <button
                type="button"
                className="button"
                style={{
                  fontWeight: 700,
                  maxHeight: 55,
                }}
                onClick={() => onConfirm(componentList)}
              >
                {componentList.length > 0 ? "Confirm" : "Close"}
              </button>
            </div>
          </div>
        ) : null}

        {showAllDoctors ? (
          <AllDoctorsDrugs handleViewMedicalGroups={handleViewMedicalGroups} />
        ) : null}

        {showMedicalGroups && doctorInfo ? (
          <SelectMedicalGroup
            doctorInfo={doctorInfo}
            AddDocDrug={AddDocDrug}
            goToSearch={handleBackButtonClick}
          />
        ) : null}
      </div>
    </div>
  );
};

export default DoctorDrugModal;
